import SearchPill from './SearchPill';

export default SearchPill;
